export const CURRENT_YEAR = new Date().getFullYear()
export const DEFAULT_START_YEAR = CURRENT_YEAR - 100
export const DEFAULT_END_YEAR = CURRENT_YEAR + 10
export const YEARS_PER_PAGE = 12
